import { Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { FilterContainer } from '../../../../containers/FilterContainer';
import { Pager, SearchInput } from '@components';
import { PageTypeContext } from '../ServerSideGrid';
import styled from 'styled-components';

const RowCounter = styled.input`
  min-width: 4rem;
  width: ${(props) => props.value.toString().length + 0.5 + 'rem'} !important;
  text-align: center;
`;

export const DefaultGridHeader = ({
  id,
  disabledFilters,
  queryState,
  setQueryState,
  rowData,
  filterKey,
  handleFilterChange,
  adjustPageSize,
  onChangeLimit,
  maxViewing,
  preventPasteNegative,
  searchControl,
  filterControl,
  viewingControl,
  pagerControl,
  exportControl,
  pageType,
  fetchCSV,
  isLoading,
  hasDateError,
}) => {
  const [pagerInputNum, setPagerInputNum] = useState<number | null | string>(null);

  useEffect(() => {
    if (pagerInputNum === '') {
      setPagerInputNum(1);
      setQueryState((prev: any) => ({ ...prev, pageNumber: 1 }));
    }
  }, [queryState.pageSize]);

  return (
    <div className="d-flex flex-row align-items-center justify-content-between">
      {/* Search & Filter */}
      {searchControl && (
        <div className="d-flex flex-row align-items-center justify-content-between">
          <SearchInput
            key={`${id}-${filterKey}`}
            id={id}
            initSearch={queryState?.filter}
            placeholder="Quick Search"
            debounceTimeSec={1}
            onChange={(e: string) => {
              if (hasDateError) return;
              setQueryState({ ...queryState, filter: e, pageNumber: 1 });
            }}
          />
          <div className="me-3" />
          {filterControl && (
            <PageTypeContext.Provider value={{ pageType }}>
              <FilterContainer
                key={filterKey}
                onChange={handleFilterChange}
                disabledFilters={disabledFilters}
                filterReportType={'asset-filter'}
              />
            </PageTypeContext.Provider>
          )}
        </div>
      )}

      {/* Page Size */}
      {viewingControl && (
        <div className="d-flex flex-row align-items-center justify-content-between text-nowrap">
          <RowCounter
            type="number"
            className="form-control form-control-sm m-2"
            min={0}
            max={maxViewing}
            pattern="[0-9]"
            value={adjustPageSize()}
            onChange={(e) => onChangeLimit(e)}
            onPaste={preventPasteNegative}
            onKeyPress={(event) => {
              if (event.charCode === 45 || event.charCode === 46) event.preventDefault();
            }}
          />
          <span> of {rowData?.count ?? rowData?.length}</span>
        </div>
      )}

      {/* Pager */}
      {pagerControl && (
        <Pager
          page={Number(queryState.pageNumber) ?? 1}
          pageCount={Math.ceil((rowData?.count ?? 0) / queryState.pageSize)}
          onChange={(e: number) => {
            setPagerInputNum(e);
            setQueryState({ ...queryState, pageNumber: e });
          }}
        />
      )}

      {/* Export Button */}
      {exportControl && (
        <Button
          size="sm"
          variant="secondary"
          onClick={fetchCSV}
          disabled={Boolean(isLoading) || queryState.pageSize === 0}
        >
          Export
        </Button>
      )}
    </div>
  );
};
